import { useNavigate, useSearchParams } from "react-router";

export const usePreserveQueryParamsNavigate = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return <T,>(path: string, state?: T) => {
    navigate(`${path}?${searchParams}`, { state });
  };
};
